export const THEME_COLORS = {
  primary: {
    "50": "#f7f7f7",
    "100": "#e0e0e0",
    "200": "#c5c5c5",
    "300": "#a6a6a6",
    "400": "#949494",
    "500": "#7d7d7d",
    "600": "#696969",
    "700": "#545454",
    "800": "#474747",
    "900": "#333333",
  },
  gray: {
    "50": "#f9fafa",
    "100": "#f1f1f2",
    // Main Colors Used
    "200": "#F4F8FF",
    "300": "#E6EAF1",
    "350": "#E6FDFF",
    "400": "#CFD6E1",
    "500": "#8E959E !important",
    "600": "#5F6873",
    "900": "#172121",
    //
    "700": "#2e3744",
    "800": "#19202b",
  },
  purple: {
    "50": "#f9f6fd",
    "100": "#e5daf8",
    "200": "#d3bef4",
    "300": "#b795ec",
    "400": "#a379e7",
    "500": "#8952e0",
    "600": "#7434db",
    "700": "#6023c0",
    "800": "#4f1d9e",
    "900": "#3b1676",
  },
  pink: {
    "50": "#fdf5f9",
    "100": "#f8d9e7",
    "200": "#f3b9d3",
    "300": "#eb8db8",
    "400": "#e56ba2",
    "500": "#dc3882",
    "600": "#c4246c",
    "700": "#a01d58",
    "800": "#7d1745",
    "900": "#5d1133",
  },
  red: {
    "50": "#fdf6f5",
    "100": "#f8d9d7",
    "200": "#f2b7b4",
    "300": "#ea8c87",
    "400": "#e5726b",
    "500": "#FD8140",
    "600": "#c72d25",
    "700": "#a1241e",
    "800": "#891f19",
    "900": "#641712",
  },
  orange: {
    "50": "#fdfaf6",
    "100": "#f9ebdb",
    "200": "#f1d4b1",
    "300": "#e6b273",
    "400": "#dc9239",
    "500": "#c37b24",
    "600": "#a5681e",
    "700": "#835318",
    "800": "#674113",
    "900": "#553610",
  },
  yellow: {
    "50": "#fffee6",
    "100": "#fdfac1",
    "200": "#fcf797",
    "300": "#faf36c",
    "400": "#f7ee46",
    "500": "#f3e913",
    "600": "#fcde1a",
    "700": "#fcc509",
    "800": "#fcac00",
    "900": "#fc8100",
  },
  brandYellow: {
    "50": "#fffee6",
    "100": "#fdfac1",
    "200": "#fcf797",
    "300": "#faf36c",
    "400": "#f7ee46",
    "500": "#f3e913",
    // Brand Yellow
    "600": "#fcde1a",
    "700": "#fcc509",
    "800": "#fcac00",
    "900": "#fc8100",
  },
  brandYellowAlphas: {
    100: "rgb(252 222 26 / 20%)",
  },
  amber: {
    "700": "#B45309",
  },
  green: {
    "50": "#f5fdf9",
    "100": "#c6f5e0",
    "150": "#D1EACD",
    "200": "#83e9bb",
    "300": "#28d889",
    "400": "#23bd78",
    "500": "#1ea367",
    "600": "#198755",
    "700": "#136942",
    "800": "#105636",
    "900": "#0d472d",
  },
  teal: {
    "50": "#f1fcfc",
    "100": "#c0f1f4",
    "200": "#84e4e9",
    "300": "#2dd1da",
    "400": "#22b2ba",
    "500": "#1d979e",
    "600": "#187b80",
    "700": "#125f64",
    "800": "#0f5053",
    "900": "#0d4244",
  },
  cyan: {
    "50": "#f4fbfd",
    "100": "#d0eef7",
    "200": "#bae7f3",
    "300": "#a2deee",
    "400": "#53c2e1",
    "500": "#2ab4d9",
    "600": "#24a2c4",
    "700": "#1e86a2",
    "800": "#196e85",
    "900": "#135567",
  },
  brandBlue: {
    "50": "#e8eaf6",
    "100": "#c6c9e9",
    "200": "#a0a6da",
    "300": "#7b84cb",
    "400": "#5f68bf",
    "500": "#444db4",
    "600": "#3e45aa",
    "700": "#363b9e",
    // Brand Blue
    "800": "#2e3192",
    "900": "#211f7d",
  },
  darkBlue: {
    "50": "#e5e6eb",
    "100": "#bcc0d0",
    "200": "#9298af",
    "300": "#6b728f",
    "400": "#4e557b",
    "500": "#333b67",
    "600": "#2d3560",
    "700": "#262c55",
    "800": "#1f2349",
    // Background Dark Blue
    "900": "#141532",
  },
  darkBlue2: {
    "50": "#e7e8ed",
    "100": "#c1c6d4",
    "200": "#9ba1b7",
    "300": "#767d99",
    "400": "#5b6386",
    "500": "#414974",
    "600": "#3b426c",
    "700": "#333961",
    "800": "#2c3054",
    // Background Dark Blue2
    "900": "#20213c",
  },
  error: {
    "50": "#ffedef",
    "100": "#ffd1d5",
    "200": "#f9a29f",
    "300": "#f27d79",
    // Primary Error
    "400": "#fe6055",
    "500": "#ff5239",
    "600": "#f64a3a",
    "700": "#e34034",
    "800": "#d6392c",
    "900": "#c72f20",
  },
};
